import { render } from "./VerPacientesAudit.vue?vue&type=template&id=d537674c"
import script from "./VerPacientesAudit.vue?vue&type=script&lang=js"
export * from "./VerPacientesAudit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__